<template>
  <div class="wrapper-base-notification-simple">
    <BaseNotificationTitle
      :code="code"
      :platform="platform"
      :dateTime="dateTime"
      :queueNumber="queueNumber"
      :tableNumber="tableNumber"
      :orderDetail="orderDetail"
    />
    <div class="action">
      <div class="buttons">
        <button
          class="btn btn-light btn-sm"
          @click="handleClickViewOrderNo">
          {{ $t('apps.pos.message.queuenumber', { number: queueNumber }) }}
        </button>
        <button
          v-if="!isRead"
          class="btn btn-light btn-sm"
          @click="handleClickRead">
          {{ $t('message.markasread') }}
        </button>
      </div>
      <div
        :style="[{ 'opacity': !isRead ? 1 : 0 }]"
        class="icon"
      >
        <i class="fas fa-circle"/>
      </div>
    </div>
  </div>
</template>
<script>
import BaseNotificationTitle from './BaseNotificationTitle.vue'

export default {
  props: {
    code: String,
    platform: String,
    dateTime: Number,
    queueNumber: String,
    tableNumber: String,
    orderDetail: Array,
    isRead: Boolean,
  },

  components: {
    BaseNotificationTitle,
  },

  methods: {
    handleClickRead() {
      this.$emit('onClickRead')
    },
    handleClickViewOrderNo() {
      this.$emit('onClickViewOrderNo')
    },
  },
}
</script>
<style scoped>
.wrapper-base-notification-simple {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 10px;
}
.action {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 15px;
}

.action .icon {
  width: 12px;
  color: #007FFF;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseNotificationItemSimple.vue